export const BACKEND_BASE_URL = 'https://civion.aispry.ai';

// for aws ec2 instance:    export const BACKEND_BASE_URL = 'http://54.186.245.181'; 